export default {
  name: ['特殊授权名称', 'Acl Name'],
  name_zh_cn: ['中文为空', 'Chinese empty'],
  name_en_us: ['英文为空', 'English empty'],
  namePlaceholder: ['请输入特殊授权名称', 'Please enter permission name'],
  nameRequire: ['当前特殊授权名称不能为空', 'Current permission name cannot be empty'],
  key: ['特殊授权代码', 'Permission Key'],
  keyHelp: [
    '特殊授权代码即需要逻辑特殊控制的标识',
    'The permission key are identifications that require special logic control'
  ],
  keyPlaceholder: ['请输入特殊授权代码', 'Please enter permission key'],
  keyRequire: ['当前特殊授权代码不能为空', 'Current permission key cannot be empty'],
  keyDuplicated: ['当前特殊授权代码已存在', 'Current permission key already exists'],
  note: ['备注', 'Note']
};
